import { render } from "./App.vue?vue&type=template&id=9d3761a0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9d3761a0&lang=scss"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__